import { SubmissionError } from 'redux-form';
import fetch from '../../core/fetch';

import { getListingDataStep3 } from '../../actions/getListingDataStep3';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import history from '../../core/history';
import messages from '../../locale/messages';
import { updateListingStep3 as query } from '../../lib/graphql';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

async function updateStep3(values, dispatch) {

  const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: values?.id }));
  if (isRestrict) {
    showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
    return;
  }

  let weeklyDiscount = Number(values?.weeklyDiscount) || 0;
  let monthlyDiscount = Number(values?.monthlyDiscount) || 0;
  let cleaningPrice = parseFloat(values?.cleaningPrice) || 0;
  let tax = parseFloat(values?.tax) || 0;

  let id, title, description ,houseRules, bookingNoticeTime, checkInStart, checkInEnd, checkOutFixed, checkOutStart, maxDaysNotice, minNight, maxNight, basePrice, currency, blockedDates, bookingType, cancellationPolicy, termsPolicy;

  id = Number(values?.id);
  title = values?.title;
  description = values?.description;
  termsPolicy = values?.termsPolicy ? true : false;
  houseRules = values?.houseRules;
  bookingNoticeTime = String(values?.bookingNoticeTime);
  checkInStart = values?.checkInStart;
  checkInEnd = values?.checkInEnd;
  checkOutFixed = values?.checkOutFixed;
  checkOutStart = values?.checkOutStart;
  maxDaysNotice = values?.maxDaysNotice;
  minNight = values?.minNight;
  maxNight = values?.maxNight;
  basePrice = parseFloat(values?.basePrice);
  currency = values?.currency;
  blockedDates = values?.blockedDates;
  bookingType = values?.bookingType;
  cancellationPolicy = values?.cancellationPolicy ? Number(values?.cancellationPolicy) : 1;

  let variables = Object.assign({}, {
    weeklyDiscount, monthlyDiscount, cleaningPrice, tax, id, houseRules, bookingNoticeTime,
    checkInStart, checkInEnd, checkOutFixed, checkOutStart, maxDaysNotice, minNight, maxNight, basePrice, currency, blockedDates, bookingType,
    cancellationPolicy, termsPolicy, title, description
  });

  dispatch(setLoaderStart('updateListing'));

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const { data } = await resp.json();

  if (data?.updateListingStep3 != undefined) {
    if (data?.updateListingStep3.status == "success") {
      await dispatch(manageListingSteps(values.id, 3));
      // Validación 100% completado: si la propiedad está lista para
      // publicarse, pasa automáticamente a publicada al concluir el formulario.
      // El backend ya intenta auto-publicar; aquí se refuerza vía managePublish
      // para que el estado quede publicado antes de ir a la previsualización.
      try {
        const listId = Number(values?.id);
        const stepsResp = await fetch('/graphql', {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            query: `query ($listId: String!) {
              showListingSteps(listId: $listId) {
                step1
                step2
                step3
                step4
                listing {
                  id
                  isReady
                  isPublished
                  listApprovalStatus
                }
              }
            }`,
            variables: { listId: String(listId) }
          }),
          credentials: 'include'
        });
        const stepsJson = await stepsResp.json();
        const steps = stepsJson?.data?.showListingSteps;
        const listing = steps?.listing;
        const isCompleteForPublish = steps
          && steps.step1 === 'completed'
          && steps.step2 === 'completed'
          && steps.step3 === 'completed'
          && listing?.isReady === true
          && listing?.isPublished !== true
          && listing?.listApprovalStatus === 'approved';
        if (isCompleteForPublish) {
          await fetch('/graphql', {
            method: 'post',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              query: `mutation ManagePublish($listId: Int!, $action: String!) {
                managePublish(listId: $listId, action: $action) {
                  status
                }
              }`,
              variables: { listId, action: 'publish' }
            }),
            credentials: 'include'
          });
        }
      } catch (e) {
        // No bloquear la navegación a la previsualización si falla el
        // auto-publicado; el backend ya dejó isReady listo para publicar manual.
      }
      history.push('/become-a-host/' + values.id + '/complete');
      await dispatch(getListingDataStep3(values.id));
      await dispatch(setLoaderComplete('updateListing'));
    } else if (data?.updateListingStep3?.status == "notLoggedIn") {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.notLoggedIn });
    } else {
      dispatch(setLoaderComplete('updateListing'));
      throw new SubmissionError({ _error: messages.somethingWentWrong });
    }
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default updateStep3;
